var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_198_187654)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 75,
    height: 75,
    rx: 18.75,
    fill: "#2F2B43"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2346 25.2049C32.0283 25.7628 32.9144 26.4003 33.4116 27.3279C33.8036 28.0579 32.9686 28.4022 32.5383 28.8166C29.1342 32.0871 25.7397 35.3672 22.2878 38.5899C21.5196 39.3071 21.5196 39.6897 22.2878 40.4069C25.7779 43.6615 29.2011 46.9926 32.6721 50.2695C33.3542 50.9134 34.0044 51.535 32.9144 52.2682C32.0857 52.826 31.6777 54.7131 30.0649 53.1448C25.6568 48.8542 21.185 44.6242 16.7131 40.4005C15.996 39.7215 16.0151 39.2593 16.7227 38.5931C21.2296 34.328 25.711 30.0342 30.1988 25.75C30.4633 25.4918 30.696 25.1763 31.2346 25.2049Z",
    fill: "#AFE7BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9943 53.8719C47.9808 53.3619 47.2349 52.5937 46.6453 51.7394C46.1321 50.9967 46.9736 50.646 47.3943 50.238C50.7984 46.9675 54.1897 43.6842 57.648 40.471C58.4544 39.7219 58.5277 39.3298 57.6735 38.5393C54.1706 35.2975 50.7569 31.96 47.2827 28.6894C46.5624 28.0105 46.0907 27.3761 47.1298 26.6716C47.968 26.1042 48.3919 24.3096 49.9888 25.8779C54.3395 30.1494 58.7795 34.3316 63.2131 38.517C63.9589 39.2215 64.0226 39.7092 63.2417 40.4455C58.7667 44.666 54.33 48.9247 49.8772 53.1675C49.6159 53.4161 49.3099 53.6201 48.9943 53.8719Z",
    fill: "#AFE7BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1013 42.2466C30.6607 42.2912 29.3475 41.0608 29.2837 39.604C29.2168 38.0899 30.5045 36.7479 32.0408 36.7383C33.4847 36.7288 34.7564 37.9975 34.7755 39.4606C34.7946 40.9237 33.5675 42.2052 32.1013 42.2466Z",
    fill: "#AFE7BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7541 39.4595C42.7764 40.9195 41.5493 42.1977 40.0767 42.2391C38.6074 42.2838 37.3197 41.082 37.2528 39.6093C37.1826 38.0793 38.4608 36.75 40.0002 36.75C41.4696 36.7532 42.7286 37.9932 42.7541 39.4595Z",
    fill: "#AFE7BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9376 42.2474C46.4905 42.2442 45.2283 40.9724 45.2188 39.5092C45.2124 38.0397 46.4555 36.7583 47.9057 36.7423C49.4452 36.7264 50.752 38.0365 50.7105 39.557C50.6755 41.0042 49.391 42.2506 47.9376 42.2474Z",
    fill: "#AFE7BB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_198_187654",
    x: 0.25,
    y: 0.5,
    width: 79.5,
    height: 79.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.168627 0 0 0 0 0.262745 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_198_187654"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_198_187654",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.168627 0 0 0 0 0.262745 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_198_187654"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLogoIcon);
export default __webpack_public_path__ + "static/media/auth-logo-icon.c2414fd29dcfbd9dc1c4f01498e66261.svg";
export { ForwardRef as ReactComponent };